$(document).ready(function () {
    var header = $('.header');
    var body = $('body');
    if (!document.getElementById('filterCollapse')) return 
    const myCollapsible = document.getElementById('filterCollapse')

    myCollapsible.addEventListener('show.bs.collapse', tabTrapActive)
})

function tabTrapActive(){
    const tabWrapper = document.getElementById('filterCollapse')
    if (!tabWrapper) return

    tabWrapper.addEventListener('keydown', tabTrapActiveEvent)
}

function tabTrapActiveEvent(event){
    const tabWrapper = document.getElementById('filterCollapse')

    if (!tabWrapper) return
  
    const tabWrapperItems = tabWrapper.querySelectorAll('.filter__content input:not(:disabled), .filter__content button:not([tabindex="-1"]):not(:disabled), .filter__content a:not(:disabled)');
    if (!tabWrapperItems || !tabWrapperItems.length) return
    const firstItem = tabWrapperItems[0];
    const lastItem = tabWrapperItems[tabWrapperItems.length - 1];
    
    if (event.key === 'Tab') {

        if (document.activeElement === lastItem && !event.shiftKey) {
            event.preventDefault();
            firstItem.focus();
          } else if (document.activeElement === firstItem && event.shiftKey) {
            event.preventDefault();
            lastItem.focus();
          }
        }
        // if (event.key === 'Escape') {
        //     $("tabWrapper").collapse({toggle: false});
        // }
     
  }